import { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "./supportedLanguages";
import { buildLocalePath, stripLocalePrefix } from "./localePath";

export function LocaleHead() {
  const { lang } = useParams<{ lang: string }>();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!lang) return;

    const bare = stripLocalePrefix(pathname);
    const origin = window.location.origin;
    const elements: HTMLLinkElement[] = [];

    document.head.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());
    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = `${origin}${buildLocalePath(lang, bare)}`;
    document.head.appendChild(canonical);
    elements.push(canonical);

    for (const { code } of SUPPORTED_LANGUAGES) {
      const alt = document.createElement("link");
      alt.rel = "alternate";
      alt.hreflang = code;
      alt.href = `${origin}${buildLocalePath(code, bare)}`;
      document.head.appendChild(alt);
      elements.push(alt);
    }

    const xDefault = document.createElement("link");
    xDefault.rel = "alternate";
    xDefault.hreflang = "x-default";
    xDefault.href = `${origin}${buildLocalePath(DEFAULT_LANGUAGE, bare)}`;
    document.head.appendChild(xDefault);
    elements.push(xDefault);

    return () => {
      for (const el of elements) el.remove();
    };
  }, [lang, pathname]);

  return null;
}
